// Recipe filtering
jQuery(function($) {
  if (!$('.recipe-filter').length) return;
  
	var filter = $('.recipe-filter');
	var offsetField = filter.find('[name="offset"]');
	var categoryfilter = filter.find('[name="categoryfilter"]');
	var tagfilter = filter.find('[name="tagfilter"]');
	var $response = $('#response');
	
	function ajaxFilter() {				
		$.ajax({
			url: filter.attr('action'),
			data: filter.serialize(), // form data
			type: filter.attr('method'), // POST
			beforeSend: function(xhr) {
				filter.find('button.submit').text('loading...'); // changing the button label				
				$response.html('<div class="loading-wrap"><div class="loading"><div class="dbl-spinner"></div><div class="dbl-spinner"></div></div></div>'); 
			},
			success: function(data) {
				filter.find('button.submit').text('filter'); // changing the button label back
				$response.html(data); // insert data

				filter.find('.clearfilters').click(function(e) {
					e.preventDefault();
					offsetField.val(0);
					categoryfilter.val('all');
					tagfilter.val('all');
					ajaxFilter();
				});
			}
		});
		return false;
	}

	categoryfilter.change(function() {
		offsetField.val(0);
		ajaxFilter();
	});

	tagfilter.change(function() {
		offsetField.val(0);
		ajaxFilter();
	});



	filter.submit(ajaxFilter);

	$response.on('click', 'button', function(e) {		
		if ($(this).hasClass('page-link')) {
			e.preventDefault();
			var offset = $(this).data('offset');
			offsetField.val(offset);						
			$('#pagination-btns li').removeClass('active');
			$(this).parent().addClass('active');
			ajaxFilter();
		}
	});	

});

// manage preferences
jQuery(function($) {
  if (!$('.klaviyo-landing-page-signup').length) return;
	var form = $('.klaviyo-landing-page-signup');
	// var message = form.find('.klaviyo_messages');

	form.submit(function() {				
		$.ajax({
            url: form.attr('action'),
            data: form.serialize(), // form data
            type: form.attr('method'), // POST
			dataType: "json",
			beforeSend: function(xhr) {
				form.find('.klaviyo_messages').html('').removeClass('error success');
				form.find('[type="submit"]').text('loading...').addClass('disabled').attr('disabled', true);
			},
			success: function(data) {
				console.log(data)
				form.find('.klaviyo_messages').addClass(data.status).html(data.message);
				form.find('[type="submit"]').text('update preferences').removeClass('disabled').attr('disabled', false);
			},
			error: function(err) {
				console.log(err)
			}
		});
		return false;
	});

});